<div
  *ngIf="caseTax && caseTax.taxType === taxType.RegularlyTaxedTaxIncluded && tax && !hideWhenTaxIncluded"
  ngClass.lt-mv="tax-mobile"
  ngClass.gt-mv="tax-web"
>
  {{ 'stockPrices.tax' | translate }}: <span class="tax-value">{{ tax }}</span>
</div>
